/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { AuthPostLogin } from './authentication-login.post';

export const AuthenticationOauth2GoogleCallbackGet = {
  id: 'authentication.oauth2.google.callback.get',
  tag: 'Authentication',
  summary: 'Callback for the Google login over OAuth2',
  description: '',
  method: 'get',
  route: () => `/authentication/google/callback`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: AuthPostLogin.response[200].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
